import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { ContactTypeCreateComponent } from '../../../features/contact/contact-type-create/contact-type-create.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { ContactTypeService } from '../../../core/services/contact/contact-type/contact-type.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { MatDialog } from '@angular/material/dialog'
import { ContactTypeEditComponent } from '../../../features/contact/contact-type-edit/contact-type-edit.component'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBar } from '@angular/material/progress-bar'
import { AuthService } from '../../../core/services/auth/auth.service'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'contact-type',
  imports: [
    MatCard,
    ContactTypeCreateComponent,
    TableListComponent,
    PaginationComponent,
    MatInputModule,
    MatProgressBar,
    FormSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './contact-type.component.html',
  styleUrl: './contact-type.component.scss',
  providers: [ContactTypeService, AuthService],
  standalone: true,
})
export class ContactTypeComponent implements OnInit {
  constructor(
    private contactTypeService: ContactTypeService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen = 'tipo contato'

  ngOnInit() {
    this.checkColumnAction()
    this.getTypeContact()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    const search = event
    // let search = this.formSearch.get('search')?.value
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchTypeContact()
    } else {
      this.getTypeContact()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchTypeContact()
    } else {
      this.getTypeContact()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getTypeContact() {
    this.loading = true
    this.contactTypeService
      .listPagedContactType(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchTypeContact() {
    this.loading = true
    this.contactTypeService
      .searchPagedContactType(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editContact(item: any) {
    const dialogRef = this.dialog.open(ContactTypeEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteContact(item: any) {
  }
}
